let heroSlideInterval;
let currentSlide = 0;

const mattresses = {
  tango: {
    closed: "https://static.wixstatic.com/media/d12b1c_4368b5b14e144637878df1963f96173b~mv2.png",
    open: "https://static.wixstatic.com/media/d12b1c_a21571afd2564dd0b63bc61e2924eb14~mv2.png",
    isOpen: false,
  },
  flamenco: {
    closed: "https://static.wixstatic.com/media/d12b1c_17d9d395ef1f45be935b94fa6219a4ed~mv2.png",
    open: "https://static.wixstatic.com/media/d12b1c_59c6c741de7e4f4698d29ed2a3a292d0~mv2.png",
    isOpen: false,
  },
};

function getHeroRoot() {
  return document.querySelector("#hero-section") || document.querySelector("[data-hero-root]");
}

function getHeroSlides(hero) {
  const root = hero || getHeroRoot();
  return root ? root.querySelectorAll(".hero-slide") : document.querySelectorAll(".hero-slide");
}

function stopSlideshow() {
  if (heroSlideInterval) {
    clearInterval(heroSlideInterval);
    heroSlideInterval = null;
  }
}

function startSlideshow() {
  stopSlideshow();
  const hero = getHeroRoot();
  if (!hero) return;
  const slides = getHeroSlides(hero);
  if (slides.length < 2) return;
  if (hero.getAttribute("data-auto-slide") === "false") return;
  const ms = parseInt(hero.getAttribute("data-auto-slide-interval") || "5000", 10) || 5000;
  heroSlideInterval = setInterval(nextSlide, Math.max(1500, ms));
}

function updateSlides(index) {
  const hero = getHeroRoot();
  const slides = getHeroSlides(hero);
  const dots = hero
    ? hero.querySelectorAll(".slide-dot")
    : document.querySelectorAll(".slide-dot");
  slides.forEach((slide) => slide.classList.remove("active-slide"));
  dots.forEach((dot) => {
    dot.classList.remove("bg-suave-champagne");
    dot.classList.add("bg-transparent");
  });
  if (slides[index]) slides[index].classList.add("active-slide");
  if (dots[index]) {
    dots[index].classList.remove("bg-transparent");
    dots[index].classList.add("bg-suave-champagne");
  }
  currentSlide = index;
}

function nextSlide() {
  const slides = getHeroSlides();
  if (!slides.length) return;
  updateSlides((currentSlide + 1) % slides.length);
}

function goToSlide(index) {
  stopSlideshow();
  updateSlides(index);
  startSlideshow();
}

function prevSlide() {
  const slides = getHeroSlides();
  if (!slides.length) return;
  stopSlideshow();
  updateSlides((currentSlide - 1 + slides.length) % slides.length);
  startSlideshow();
}

function initHeroCarouselControls() {
  const hero = getHeroRoot();
  if (!hero) return;

  hero.querySelectorAll("[data-suave-dot]").forEach((dot) => {
    if (dot.dataset.heroDotBound === "1") return;
    dot.dataset.heroDotBound = "1";
    dot.addEventListener("click", (e) => {
      e.preventDefault();
      const idx = parseInt(dot.getAttribute("data-suave-dot"), 10);
      if (!Number.isNaN(idx)) goToSlide(idx);
    });
  });

  const prevBtn = hero.querySelector("[data-hero-prev]");
  const nextBtn = hero.querySelector("[data-hero-next]");
  if (prevBtn && prevBtn.dataset.heroBtnBound !== "1") {
    prevBtn.dataset.heroBtnBound = "1";
    prevBtn.addEventListener("click", (e) => { e.preventDefault(); prevSlide(); });
  }
  if (nextBtn && nextBtn.dataset.heroBtnBound !== "1") {
    nextBtn.dataset.heroBtnBound = "1";
    nextBtn.addEventListener("click", (e) => { e.preventDefault(); nextSlide(); });
  }
}

function initSuaveNavDropdowns(root) {
  const scope = root || document;
  const canHover = () => {
    try {
      return window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    } catch (e) {
      return true;
    }
  };
  scope.querySelectorAll("[data-suave-nav-dropdown]").forEach((dropdown) => {
    const trigger = dropdown.querySelector("[data-suave-nav-dropdown-trigger]");
    if (!trigger || trigger.dataset.suaveNavBound === "1") return;
    trigger.dataset.suaveNavBound = "1";

    // Keep is-open in sync with hover so the panel stays open while moving onto it
    // (important when the nav overlays the hero).
    dropdown.addEventListener("mouseenter", () => {
      if (!canHover()) return;
      scope.querySelectorAll("[data-suave-nav-dropdown].is-open").forEach((other) => {
        if (other === dropdown) return;
        other.classList.remove("is-open");
        const otherTrigger = other.querySelector("[data-suave-nav-dropdown-trigger]");
        if (otherTrigger) otherTrigger.setAttribute("aria-expanded", "false");
      });
      dropdown.classList.add("is-open");
      trigger.setAttribute("aria-expanded", "true");
    });
    dropdown.addEventListener("mouseleave", () => {
      if (!canHover()) return;
      dropdown.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");
    });

    const panel = dropdown.querySelector(".suave-nav-dropdown-panel");
    if (panel) {
      panel.addEventListener("click", (e) => e.stopPropagation());
    }

    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const open = dropdown.classList.toggle("is-open");
      trigger.setAttribute("aria-expanded", open ? "true" : "false");
      scope.querySelectorAll("[data-suave-nav-dropdown].is-open").forEach((other) => {
        if (other === dropdown) return;
        other.classList.remove("is-open");
        const otherTrigger = other.querySelector("[data-suave-nav-dropdown-trigger]");
        if (otherTrigger) otherTrigger.setAttribute("aria-expanded", "false");
      });
    });
  });

  scope.querySelectorAll("[data-suave-nav-mobile-trigger]").forEach((btn) => {
    if (btn.dataset.suaveNavBound === "1") return;
    btn.dataset.suaveNavBound = "1";
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const group = btn.closest("[data-suave-nav-group]");
      const panel = group ? group.querySelector(".suave-nav-mobile-children") : null;
      if (!panel) return;
      const expanded = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", expanded ? "false" : "true");
      panel.hidden = expanded;
      group.classList.toggle("is-expanded", !expanded);
    });
  });
}

function toggleMattress(id) {
  const data = mattresses[id];
  if (!data) return;
  data.isOpen = !data.isOpen;
  const img = document.getElementById(`${id}-img`);
  const arrow = document.getElementById(`${id}-arrow`);
  if (img) img.style.opacity = "0";
  setTimeout(() => {
    if (!img) return;
    img.src = data.isOpen ? data.open : data.closed;
    img.style.opacity = "1";
  }, 300);
  if (arrow) arrow.style.transform = data.isOpen ? "rotate(180deg)" : "rotate(0deg)";
}

/**
 * Shopify product cards: gallery from data-suave-gallery (JSON URL array), or legacy two-image
 * data-img-closed / data-img-open. Optional data-suave-gallery-alts (JSON string array).
 * Shift+click cycles backward when multiple images.
 */
function parseSuaveProductGallery(card) {
  const galleryRaw = card.getAttribute("data-suave-gallery");
  let urls = [];
  if (galleryRaw) {
    try {
      urls = JSON.parse(galleryRaw);
    } catch (e) {
      urls = [];
    }
  }
  if (!Array.isArray(urls)) urls = [];

  const altsRaw = card.getAttribute("data-suave-gallery-alts");
  let alts = [];
  if (altsRaw) {
    try {
      alts = JSON.parse(altsRaw);
    } catch (e) {
      alts = [];
    }
  }
  if (!Array.isArray(alts)) alts = [];

  return { urls, alts };
}

function setSuaveProductCardImage(card, img, index) {
  const { urls, alts } = parseSuaveProductGallery(card);
  if (!img || !urls.length || index < 0 || index >= urls.length) return;

  img.style.opacity = "0";
  window.setTimeout(function () {
    img.src = urls[index];
    if (alts[index]) img.setAttribute("alt", alts[index]);
    img.style.opacity = "1";
  }, 200);

  card.setAttribute("data-gallery-index", String(index));
}

function initSuaveProductCardHover(root) {
  const scope = root || document;
  scope.querySelectorAll("[data-suave-product-card]").forEach(function (card) {
    if (card.dataset.suaveProductHoverInit === "1") return;

    const media = card.querySelector("[data-suave-product-card-media]");
    const img = card.querySelector("[data-mattress-img]");
    if (!media || !img) return;

    const { urls } = parseSuaveProductGallery(card);
    if (urls.length < 2) return;

    card.dataset.suaveProductHoverInit = "1";

    media.addEventListener("mouseenter", function () {
      setSuaveProductCardImage(card, img, 1);
    });

    media.addEventListener("mouseleave", function () {
      setSuaveProductCardImage(card, img, 0);
    });
  });
}

function toggleMattressCard(btn, ev) {
  const root = btn.closest("[data-suave-product-card]");
  if (!root) return;
  const img = root.querySelector("[data-mattress-img]");
  const arrow = root.querySelector("[data-mattress-arrow]");
  const galleryRaw = root.getAttribute("data-suave-gallery");
  let urls = [];
  if (galleryRaw) {
    try {
      urls = JSON.parse(galleryRaw);
    } catch (e) {
      urls = [];
    }
  }
  if (!Array.isArray(urls)) urls = [];

  const altsRaw = root.getAttribute("data-suave-gallery-alts");
  let alts = [];
  if (altsRaw) {
    try {
      alts = JSON.parse(altsRaw);
    } catch (e) {
      alts = [];
    }
  }

  const go = (nextIdx) => {
    if (img) img.style.opacity = "0";
    setTimeout(() => {
      if (!img) return;
      img.src = urls[nextIdx];
      if (alts[nextIdx]) img.setAttribute("alt", alts[nextIdx]);
      img.style.opacity = "1";
    }, 300);
    if (arrow) arrow.style.transform = nextIdx % 2 === 0 ? "rotate(0deg)" : "rotate(180deg)";
  };

  if (urls.length > 1) {
    const shift = ev && ev.shiftKey;
    let idx = parseInt(root.getAttribute("data-gallery-index") || "0", 10);
    if (Number.isNaN(idx)) idx = 0;
    idx = shift ? (idx - 1 + urls.length) % urls.length : (idx + 1) % urls.length;
    root.setAttribute("data-gallery-index", String(idx));
    go(idx);
    return;
  }

  const closed = root.getAttribute("data-img-closed");
  const open = root.getAttribute("data-img-open");
  if (!closed || !open || closed === open) return;
  const isOpen = root.getAttribute("data-mattress-open") === "true";
  const next = !isOpen;
  root.setAttribute("data-mattress-open", next ? "true" : "false");
  if (img) img.style.opacity = "0";
  setTimeout(() => {
    if (!img) return;
    img.src = next ? open : closed;
    img.style.opacity = "1";
  }, 300);
  if (arrow) arrow.style.transform = next ? "rotate(180deg)" : "rotate(0deg)";
}

function initHeroNav(section) {
  const toggle = section.querySelector("[data-suave-hero-nav-toggle]");
  if (!toggle || toggle.dataset.suaveHeroNavBound === "1") return;
  toggle.dataset.suaveHeroNavBound = "1";
  const controlId = toggle.getAttribute("aria-controls");
  const panel = controlId ? document.getElementById(controlId) : null;
  if (!panel) return;
  const drawer = panel.querySelector("[data-suave-hero-nav-drawer]");
  const backdrop = panel.querySelector("[data-suave-hero-nav-backdrop]");
  const closeBtn = panel.querySelector("[data-suave-hero-nav-close]");
  if (!drawer) return;

  const isOpen = () => panel.classList.contains("is-open");

  const setOpen = (open) => {
    panel.classList.toggle("is-open", open);
    panel.setAttribute("aria-hidden", open ? "false" : "true");
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    document.body.style.overflow = open ? "hidden" : "";
  };

  toggle.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(!isOpen());
  });

  if (backdrop) {
    backdrop.addEventListener("click", (e) => {
      e.preventDefault();
      setOpen(false);
    });
  }
  if (closeBtn) closeBtn.addEventListener("click", () => setOpen(false));

  panel.querySelectorAll("a").forEach((a) => a.addEventListener("click", () => setOpen(false)));

  const onDocClick = (e) => {
    if (!isOpen()) return;
    if (panel.contains(e.target) || toggle.contains(e.target)) return;
    setOpen(false);
  };
  const onKeyDown = (e) => {
    if (e.key === "Escape") setOpen(false);
  };
  document.addEventListener("click", onDocClick);
  document.addEventListener("keydown", onKeyDown);

  // The site header switches menu <-> burger at 900px (data-nav-breakpoint); other navs keep 768px.
  const navBreakpoint = parseInt(toggle.getAttribute("data-nav-breakpoint"), 10) || 768;
  const mq = window.matchMedia("(min-width: " + navBreakpoint + "px)");
  const onMq = () => setOpen(false);
  mq.addEventListener("change", onMq);

  const shopifySection = section.closest("[id^='shopify-section-']");
  const onSectionUnload = (e) => {
    if (!shopifySection || `shopify-section-${e.detail.sectionId}` !== shopifySection.id) return;
    document.removeEventListener("click", onDocClick);
    document.removeEventListener("keydown", onKeyDown);
    mq.removeEventListener("change", onMq);
    document.removeEventListener("shopify:section:unload", onSectionUnload);
    document.body.style.overflow = "";
  };
  if (shopifySection) {
    document.addEventListener("shopify:section:unload", onSectionUnload);
  }

  if (mq.matches) {
    setOpen(false);
  }
}

function toggleFaq(button) {
  const content = button.nextElementSibling;
  const icon = button.querySelector("svg") || button.querySelector("i");
  const isOpen = content?.style.maxHeight && content.style.maxHeight !== "0px";
  document.querySelectorAll(".faq-btn").forEach((btn) => {
    const panel = btn.nextElementSibling;
    const panelIcon = btn.querySelector("svg") || btn.querySelector("i");
    if (panel) {
      panel.style.maxHeight = "0px";
      panel.style.opacity = "0";
    }
    if (panelIcon) panelIcon.style.transform = "rotate(0deg)";
  });
  if (!isOpen && content) {
    content.style.maxHeight = `${content.scrollHeight}px`;
    content.style.opacity = "1";
    if (icon) icon.style.transform = "rotate(45deg)";
  }
}

function resolveStickyHeroTarget(stickyBar) {
  const selector =
    (stickyBar && stickyBar.getAttribute("data-hero-target")) ||
    "[data-hero-root]";
  let hero = null;
  try {
    hero = document.querySelector(selector);
  } catch (err) {
    hero = null;
  }
  if (!hero) hero = document.getElementById("hero-section");
  if (!hero) hero = document.querySelector("[data-hero-root]");
  if (!hero) hero = document.querySelector(".suave-lp-hero");
  if (!hero) hero = document.querySelector(".section-suave-lp-hero");
  return hero;
}

function syncSuaveCartMirror(target, source) {
  if (!target || !source) return;
  target.innerHTML = source.innerHTML;
  target.classList.toggle("suave-nav-utilities__cart--empty", source.classList.contains("suave-nav-utilities__cart--empty"));
}

function openSuaveCartDrawer(triggeredBy) {
  const drawer = document.querySelector("cart-drawer");
  if (!drawer || typeof drawer.open !== "function") return false;
  drawer.open(triggeredBy || undefined);
  return true;
}

function initSuaveCartMirrors() {
  const candidates = document.querySelectorAll("[data-suave-cart-mirror-candidate]");
  if (!candidates.length) return;

  const primary = document.getElementById("cart-icon-bubble");

  candidates.forEach((candidate) => {
    if (primary && primary !== candidate) {
      candidate.dataset.suaveCartMirror = "true";
      syncSuaveCartMirror(candidate, primary);
      if (!candidate.dataset.suaveCartMirrorBound) {
        candidate.dataset.suaveCartMirrorBound = "true";
        candidate.setAttribute("role", "button");
        candidate.setAttribute("aria-haspopup", "dialog");
        candidate.addEventListener("click", (event) => {
          if (openSuaveCartDrawer(candidate)) event.preventDefault();
        });
        candidate.addEventListener("keydown", (event) => {
          if (event.code.toUpperCase() !== "SPACE") return;
          event.preventDefault();
          openSuaveCartDrawer(candidate);
        });
      }
      return;
    }

    if (!document.getElementById("cart-icon-bubble")) {
      candidate.id = "cart-icon-bubble";
      candidate.removeAttribute("data-suave-cart-mirror-candidate");
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer && typeof cartDrawer.setHeaderCartIconAccessibility === "function") {
        cartDrawer.setHeaderCartIconAccessibility();
      }
    }
  });

  if (primary && !primary.dataset.suaveCartMirrorObserver) {
    primary.dataset.suaveCartMirrorObserver = "true";
    const observer = new MutationObserver(() => {
      document.querySelectorAll('[data-suave-cart-mirror="true"]').forEach((mirror) => {
        syncSuaveCartMirror(mirror, primary);
      });
    });
    observer.observe(primary, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });
  }
}

function syncSuaveStickyShopBar() {
  const stickyBar = document.getElementById("sticky-bar");
  if (!stickyBar) return;

  const stickySection = stickyBar.closest(".section-suave-sticky-shop-bar");
  if (stickySection) stickySection.classList.remove("is-suave-sticky-inactive");

  const heroSection = resolveStickyHeroTarget(stickyBar);
  var shouldShow = false;

  if (heroSection) {
    // With a hero: show after the hero scrolls out of view
    shouldShow = heroSection.getBoundingClientRect().bottom < 0;
  } else {
    // No hero (product/cart/etc.): show after a short scroll so blank
    // "Show only on these pages" still works site-wide.
    var threshold = 80;
    var header = document.querySelector(".section-suave-nav-bar, #shopify-section-header, header");
    if (header) threshold = Math.max(threshold, Math.round(header.getBoundingClientRect().height || 0));
    shouldShow = window.scrollY > threshold;
  }

  // Visibility is controlled only by CSS (.is-suave-sticky-visible).
  stickyBar.classList.toggle("is-suave-sticky-visible", shouldShow);
}

window.addEventListener("scroll", syncSuaveStickyShopBar, { passive: true });
window.addEventListener("resize", syncSuaveStickyShopBar, { passive: true });
document.addEventListener("DOMContentLoaded", syncSuaveStickyShopBar);

document.addEventListener("DOMContentLoaded", () => {
  const heroRoot = document.querySelector("#hero-section") || document.querySelector("[data-hero-root]");
  if (heroRoot) initHeroNav(heroRoot);
  document.querySelectorAll("[data-suave-nav-root]").forEach((navRoot) => {
    if (heroRoot && heroRoot.contains(navRoot)) return;
    initHeroNav(navRoot);
  });

  initSuaveNavDropdowns(document);
  initHeroCarouselControls();
  initSuaveProductCardHover(document);
  startSlideshow();
  initSuaveCartMirrors();
  syncSuaveStickyShopBar();

  document.addEventListener("shopify:section:load", function (e) {
    const section = document.getElementById("shopify-section-" + e.detail.sectionId);
    if (!section) return;
    initSuaveProductCardHover(section);
    section.querySelectorAll("[data-suave-nav-root]").forEach((navRoot) => {
      const toggle = navRoot.querySelector("[data-suave-hero-nav-toggle]");
      if (toggle) delete toggle.dataset.suaveHeroNavBound;
      initHeroNav(navRoot);
    });
    initSuaveNavDropdowns(section);
    initSuaveCartMirrors();
    syncSuaveStickyShopBar();
    if (section.querySelector("#hero-section, [data-hero-root]")) {
      currentSlide = 0;
      initHeroCarouselControls();
      startSlideshow();
    }
  });

  document.addEventListener("click", (e) => {
    // Don't close when clicking a dropdown link (let navigation proceed)
    if (e.target && e.target.closest && e.target.closest("[data-suave-nav-dropdown]")) return;
    document.querySelectorAll("[data-suave-nav-dropdown].is-open").forEach((dropdown) => {
      dropdown.classList.remove("is-open");
      const trigger = dropdown.querySelector("[data-suave-nav-dropdown-trigger]");
      if (trigger) trigger.setAttribute("aria-expanded", "false");
    });
  });
  if (window.lucide && typeof window.lucide.createIcons === "function") {
    window.lucide.createIcons();
  }
  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        obs.unobserve(entry.target);
      });
    },
    { root: null, rootMargin: "0px", threshold: 0.15 }
  );
  document.querySelectorAll(".animate-fade-in-up").forEach((el) => observer.observe(el));
});



(function () {
  var gallery = document.querySelector("[data-collection-gallery]");
  if (!gallery || gallery.dataset.suaveGalleryInit === "1") return;
  gallery.dataset.suaveGalleryInit = "1";

  var main = gallery.querySelector("[data-collection-gallery-main]");
  var thumbs = gallery.querySelectorAll("[data-collection-thumb]");
  if (!main || !thumbs.length) return;

  thumbs.forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      var src = thumb.getAttribute("data-image-src");
      var alt = thumb.getAttribute("data-image-alt") || "Flamenco gallery image";
      if (!src) return;
      main.src = src;
      main.alt = alt;
      thumbs.forEach(function (t) {
        t.classList.remove("is-active");
      });
      thumb.classList.add("is-active");
    });
  });
})();

(function () {
  if (document.documentElement.dataset.suaveCollectionLayersBound === "1") return;
  document.documentElement.dataset.suaveCollectionLayersBound = "1";

  function setCaret(el, open) {
    var caret = el.querySelector(".collection-layer-caret");
    if (caret) caret.textContent = open ? "▲" : "▼";
  }

  function setActive(layers, layerId) {
    if (!layerId) return;
    layers.querySelectorAll("[data-layer-pin]").forEach(function (pin) {
      pin.classList.toggle("is-active", pin.getAttribute("data-layer-pin") === layerId);
    });
    layers.querySelectorAll("[data-layer-option]").forEach(function (opt) {
      var isActive = opt.getAttribute("data-layer-option") === layerId;
      opt.classList.toggle("is-active", isActive);
      setCaret(opt, isActive);
    });
    layers.querySelectorAll("[data-layer-item]").forEach(function (item) {
      item.classList.toggle("is-open", item.getAttribute("data-layer-item") === layerId);
    });
  }

  function applyMappedFirmnessTab(label) {
    if (!label) return;
    document.querySelectorAll("[data-collection-layers-section], [data-pdp-collection-layers-section]").forEach(function (section) {
      var tabs = section.querySelectorAll("[data-firmness-tab]");
      var match = null;
      tabs.forEach(function (tab) {
        if (match) return;
        var mapLabel = tab.getAttribute("data-map-firmness-label");
        if (mapLabel && mapLabel.trim() === label) {
          match = tab;
        }
      });
      if (match) {
        match.click();
      }
    });
  }

  document.addEventListener("click", function (e) {
    var tabBtn = e.target.closest("[data-firmness-tab]");
    if (tabBtn) {
      var section = tabBtn.closest("[data-collection-layers-section], [data-pdp-collection-layers-section]");
      if (!section) return;
      var targetId = tabBtn.getAttribute("data-firmness-tab");
      if (!targetId) return;
      section.querySelectorAll("[data-firmness-tab]").forEach(function (b) {
        var active = b === tabBtn;
        b.classList.toggle("is-active", active);
        b.setAttribute("aria-selected", active ? "true" : "false");
      });
      section.querySelectorAll("[data-firmness-panel]").forEach(function (p) {
        var match = p.getAttribute("data-firmness-panel") === targetId;
        p.classList.toggle("is-active", match);
        p.hidden = !match;
      });
      var panel = section.querySelector(
        '[data-firmness-panel="' + targetId + '"][data-collection-layers]'
      );
      if (panel) setActive(panel, "1");
      return;
    }

    var layers = e.target.closest("[data-collection-layers]");
    if (!layers || layers.hidden) return;
    var pin = e.target.closest("[data-layer-pin]");
    if (pin) {
      setActive(layers, pin.getAttribute("data-layer-pin"));
      return;
    }
    var opt = e.target.closest("[data-layer-option]");
    if (opt) {
      setActive(layers, opt.getAttribute("data-layer-option"));
    }
  });

  document.addEventListener("suave:firmness-change", function (e) {
    if (!e || !e.detail) return;
    applyMappedFirmnessTab(e.detail.label);
  });
})();

